import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=297660fe&scoped=true&"
import script from "./SidebarModal.vue?vue&type=script&lang=js&"
export * from "./SidebarModal.vue?vue&type=script&lang=js&"
import style0 from "./SidebarModal.vue?vue&type=style&index=0&id=297660fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297660fe",
  null
  
)

export default component.exports